<q-layout><q-page-container class="login-bg"><router-view></router-view></q-page-container></q-layout>